import React from 'react';
import { connect } from 'react-redux';
import { createPopup, closePopup } from '../../../services/popupService';
import {
  ContentWrapper,
  Header,
  PopupContent,
  PopupImage,
  PopupTextBlock,
  ConfirmButton,
  DismissButton,
} from '../Popups.styles';
import { getExtraBusinessInfoOfSelectedTicket } from 'extractFromState';
import { selectSubscriptionSystem } from 'selectors/tools';
import { SUBSCRIPTION_SYSTEMS } from 'constants/integrations';
import { DropdownReason, PopupTextAreaCancellationNote } from './SelectCancellationReasonPopup.styles';

class CancellationReasonPopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedReason: null,
      cancellationNote: null,
    };
  }

  handleConfirmClick = () => {
    const onConfirmCallback = this.props.onConfirm;
    const cancellationReason = this.state.selectedReason;
    const cancellationNote = this.state.cancellationNote;

    if (onConfirmCallback) {
      onConfirmCallback({ cancellationReason, cancellationNote });
    }

    closePopup();
  };

  isReasonOtherSelected = () => {
    const selectedReason = this.state.selectedReason || '';

    return selectedReason.toLowerCase() === 'other';
  };

  shouldShowCancellationNote = () =>
    this.isReasonOtherSelected() && this.props.subscriptionSystem === SUBSCRIPTION_SYSTEMS.SIMPLR_ORDER;

  render() {
    return (
      <div>
        <ContentWrapper>
          <PopupContent>
            <PopupImage src="/images/green-alert-bell.svg" />
            <PopupTextBlock>
              <Header>Please select the cancellation reason</Header>
            </PopupTextBlock>
            <PopupTextBlock>
              <DropdownReason
                value={this.state.selectedReason}
                onChange={({ target: { value } }) => this.setState({ selectedReason: value })}
              >
                <option selected disabled>
                  Select a reason
                </option>
                {this.props.cancellationReasons.map((option) => (
                  <option key={`${option}`}>{option}</option>
                ))}
              </DropdownReason>
              {this.shouldShowCancellationNote() && (
                <PopupTextAreaCancellationNote
                  placeholder="Please add cancellation Note here..."
                  data-gramm_editor="false"
                  onChange={({ target: { value } }) => this.setState({ cancellationNote: value })}
                  value={this.state.cancellationNote}
                />
              )}
            </PopupTextBlock>
          </PopupContent>
        </ContentWrapper>
        <DismissButton onClick={() => closePopup()}>DISMISS</DismissButton>
        <ConfirmButton disabled={!this.state.selectedReason} onClick={() => this.handleConfirmClick()}>
          CONFIRM
        </ConfirmButton>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cancellationReasons: getExtraBusinessInfoOfSelectedTicket(state).cancellationReasons || [],
  subscriptionSystem: selectSubscriptionSystem(state),
});

const SelectCancellationReasonPopup = connect(mapStateToProps)(CancellationReasonPopup);

const openSelectCancellationReasonPopup = async ({ onConfirm }) =>
  createPopup({
    type: 'SelectCancellationReasonPopup',
    content: <SelectCancellationReasonPopup onConfirm={onConfirm} />,
  });

export default openSelectCancellationReasonPopup;
